import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { selectJoinRequests } from 'store/selectors';

import { List } from 'wui/List';
import { Divider } from 'wui/Divider';
import { CounterBadge } from 'wui/CounterBadge';
import { Accordion, AccordionItem } from 'wui/Accordion';

import { PENDING_MEMBERS_EXPAND } from '../../dataHooks';

import { JoinRequest } from './JoinRequest';

interface IPendingMembersProps {
  groupId: string;
  initiallyExpanded?: boolean;
}

const ACCORDION_ITEM_ID = 'pending members';

export function JoinRequests(props: IPendingMembersProps) {
  const { groupId, initiallyExpanded } = props;

  const { t } = useTranslation();

  const { metadata, requests } = useSelector(selectJoinRequests);

  if (!requests.length) {
    return null;
  }

  return (
    <Accordion
      data-hook={PENDING_MEMBERS_EXPAND}
      initiallyExpanded={initiallyExpanded ? ACCORDION_ITEM_ID : undefined}
    >
      <AccordionItem
        id="pending members"
        title={t('groups-web.members.pending.requests')}
        suffix={
          <CounterBadge color="danger" value={metadata.count as number} />
        }
      >
        <List disablePadding gap="SP3" separator={<Divider />}>
          {requests.map((request) => (
            <JoinRequest
              key={request.profile.siteMemberId}
              groupId={groupId}
              request={request}
            />
          ))}
        </List>
      </AccordionItem>
    </Accordion>
  );
}

JoinRequests.displayName = 'JoinRequests';
